import store from "@/store";

function stationIdInList(stationId, list) {
	return (list || []).some((s) => String(s) === String(stationId));
}

export class ProductOrderService {
	constructor() {}

	/**
	 * Indica si el ítem de pedido se trata como "ghost" (fuera del foco de estaciones) para la cocina.
	 * - Lista de exclusión: ghost si el producto intersecta excludedStations (con ids de partida).
	 * - Solo exclusión en partidas reales, sin «Ver sin partidas»: sin ids de partida en el producto →
	 *   ghost si showProductOrdersWithoutElaborationWhenExcludingOnly es false.
	 * - Sin ninguna partida en Ver/Ocultar y «Ocultar» en Sin partidas: ocultar solo ítems sin partida (sin
	 *   necesidad de haber marcado Ocultar en una partida concreta).
	 * - «Solo» en partidas (selectedStations) y/o «Solo sin partidas» (onlyProductOrdersWithoutElaborationStation):
	 *   visible si cumple cualquiera de las dos (unión): sin partida con id, o parte de la lista incluida.
	 */
	checkIsGhostProductOrder(productOrder) {
		const showAll = store.getters["copilot/showAllProductOrdersInKitchen"];
		const onlyNoStation = store.getters["copilot/onlyProductOrdersWithoutElaborationStation"];
		const includeIds = store.getters["copilot/selectedStations"] || [];
		const excludeIds = store.getters["copilot/excludedStations"] || [];
		const showWithoutWhenExcludingOnly = store.getters["copilot/showProductOrdersWithoutElaborationWhenExcludingOnly"];

		const hideSinPartidaSinOtrasPartidas =
			!onlyNoStation &&
			includeIds.length === 0 &&
			excludeIds.length === 0 &&
			showWithoutWhenExcludingOnly === false;

		const hasActiveStationFilter =
			excludeIds.length > 0 ||
			includeIds.length > 0 ||
			onlyNoStation ||
			hideSinPartidaSinOtrasPartidas;

		/* «Todas las partidas» solo anula filtros si no hay ninguno; si el estado quedó incoherente
		 * (showAll true pero hay exclusiones / Ver / etc.), seguimos evaluando. */
		if (showAll && !hasActiveStationFilter) {
			return false;
		}

		const stations = productOrder?.elaborationStations;
		const hasStationList = Array.isArray(stations) && stations.length > 0;
		const productElaborationStationIds = hasStationList
			? stations.map((es) => es?.id).filter((id) => id != null)
			: [];
		const hasStationIds = productElaborationStationIds.length > 0;

		if (excludeIds.length > 0 && hasStationIds) {
			if (productElaborationStationIds.some((id) => stationIdInList(id, excludeIds))) {
				return true;
			}
		}

		if (excludeIds.length > 0 && includeIds.length === 0 && !onlyNoStation) {
			if (!hasStationIds) return !showWithoutWhenExcludingOnly;
		}

		if (hideSinPartidaSinOtrasPartidas) {
			if (!hasStationIds) return true;
			return false;
		}

		if (onlyNoStation || includeIds.length > 0) {
			const matchesNoStationLeg = onlyNoStation && !hasStationIds;
			const matchesStationLeg =
				includeIds.length > 0 &&
				hasStationIds &&
				productElaborationStationIds.some((id) => stationIdInList(id, includeIds));
			const visible = matchesNoStationLeg || matchesStationLeg;
			return !visible;
		}

		return false;
	}
}

export const productOrderService = new ProductOrderService();
